var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5685 14.5C12.2821 14.5 12.0499 14.2678 12.0499 13.9814V8.25097C12.0499 7.97429 12.2742 7.75 12.5509 7.75C12.8276 7.75 13.0519 7.97429 13.0519 8.25097V8.76953H13.1222C13.2452 8.43554 13.4679 8.16455 13.7902 7.95654C14.1124 7.74853 14.4757 7.64453 14.88 7.64453C14.9562 7.64453 15.0514 7.646 15.1656 7.64893C15.313 7.6527 15.4249 7.77436 15.4249 7.92177V8.47181C15.4249 8.59625 15.3065 8.69444 15.1832 8.67724C15.0602 8.65673 14.9298 8.64648 14.7921 8.64648C14.464 8.64648 14.171 8.71533 13.9132 8.85302C13.6583 8.98779 13.4562 9.17529 13.3068 9.41552C13.1603 9.65282 13.087 9.92382 13.087 10.2285V13.9814C13.087 14.2678 12.8549 14.5 12.5685 14.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54492 14.5C5.24397 14.5 5 14.256 5 13.955V6.53124C5 5.9617 5.4617 5.5 6.03124 5.5H9.91306C10.18 5.5 10.3965 5.71642 10.3965 5.9834C10.3965 6.25037 10.18 6.46679 9.91306 6.46679H6.08984V9.50779H9.50877C9.77574 9.50779 9.99216 9.72422 9.99216 9.99119C9.99216 10.2582 9.77574 10.4746 9.50877 10.4746H6.08984V13.955C6.08984 14.256 5.84587 14.5 5.54492 14.5Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFr);
export default ForwardRef;